export const formatMetricValue = (value: number | undefined) => {
  if (!value) return { value: '--', unit: '' };

  if (isNaN(value)) return { value: '--', unit: '' };

  const isValueBelow1k = value < 1000;
  const formattedValue = isValueBelow1k ? value.toFixed(2) : (value / 1000).toFixed(2);
  const unit = isValueBelow1k ? 'kWh' : 'MWh';

  return { value: formattedValue, unit };
};

export function convertPowerFromKW(kilowatts?: number | null): {
  value: number | undefined;
  unit: 'kW' | 'MW' | 'GW' | undefined;
  label: string;
} {
  if (kilowatts == null) {
    return {
      value: undefined,
      unit: undefined,
      label: '--',
    };
  }

  let value: number;
  let unit: 'kW' | 'MW' | 'GW';

  if (kilowatts >= 1_000_000) {
    value = kilowatts / 1_000_000;
    unit = 'GW';
  } else if (kilowatts >= 1_000) {
    value = kilowatts / 1_000;
    unit = 'MW';
  } else {
    value = kilowatts;
    unit = 'kW';
  }

  return {
    value,
    unit,
    label: `${value} ${unit}`,
  };
}

export function convertEnergyFromKWh(kilowattHours?: number | null): {
  value: number | undefined;
  unit: 'kWh' | 'MWh' | 'GWh' | undefined;
  label: string;
} {
  const kilowattHoursNumber = Number(kilowattHours);
  if (kilowattHoursNumber == null || isNaN(kilowattHoursNumber)) {
    return {
      value: undefined,
      unit: undefined,
      label: '--',
    };
  }

  let value: number;
  let unit: 'kWh' | 'MWh' | 'GWh';

  if (kilowattHoursNumber >= 1_000_000) {
    value = kilowattHoursNumber / 1_000_000;
    unit = 'GWh';
  } else if (kilowattHoursNumber >= 1_000) {
    value = kilowattHoursNumber / 1_000;
    unit = 'MWh';
  } else {
    value = kilowattHoursNumber;
    unit = 'kWh';
  }

  value = Number(value?.toFixed(2));

  return {
    value,
    unit,
    label: `${value} ${unit}`,
  };
}
